export default __webpack_public_path__ + "static/media/units.5d94b091.svg";